<template>
  <div>
    <div class="h-dialogContainer">
      <template>
        <!-- <div class="h-dialog-borderBox-topIcon">as
           <div class="h-toolbarBg dialog-icon-style">
        <ejs-toolbar class="dialog-icon-style">
                  </ejs-toolbar>
           </div>
        </div>-->
        <ParseForm
          ref="basic"
          :formId="formItems.basic.formId"
          :formParams="formItems.basic.formObj"
          :opCode="opCode"
        ></ParseForm>

        <!-- </div> -->
      </template>
      <template>
        <ParseList
          ref="staticIp"
          :formId="formItems.staticIp.formId"
          :formParams="formItems.staticIp.formObj"
          :opCode="opCode"
          :Title="formItems.staticIp.title"
          :maxLength="formItems.staticIp.maxLength"
          :minLength="formItems.staticIp.minLength"
        ></ParseList>
      </template>
    </div>
  </div>
</template>
<script>
import ParseForm from "../../../util/parseFormNew/ParseForm";
import ParseList from "../../../util/parseFormNew/ParseList";
import CustomDialog from "../../../../common/CustomDialog";
import SubscriberTool from "../../../util/parseFormNew/tools/subscriberTool";
import ajaxUrl from "../../../data/ajaxUrl";
import { EventBus } from "../../../../../plugins/eventBus";

export default {
  name: "AddProfileForm",
  components: {
    ParseForm,
    CustomDialog,
    ParseList
  },
  methods: {
    getDatas() {
      const map = new Map();
      if (this.$refs.basic) {
        if (!this.$refs.basic.validateResult()) {
          console.log("表单验证不通过");
          return;
        }
        const maps = this.$refs.basic.getDatas();
        for (const [key, value] of maps.entries()) {
          map.set(key, value);
        }
      }
      if (this.$refs.staticIp) {
        if (!this.$refs.staticIp.validateResult()) {
          return;
        }
        const staticIp = this.$refs.staticIp.getDatas();
        map.set("staticIpObj", staticIp.list);
      }
      return map;
    },
    getJson(ne, callback) {
      this.ne = ne;
      const params = {
        msgid: this.msgId,
        neid: ne.neid
      };
      this.$axios
        .post("/lte/ems/subscriber/epcunms/getGParamJson", params)
        .then(response => {
          if (!response) {
            console.log("getJson response error");
            return;
          }
          if (!response.data) {
            console.log("getJson response.data error");
            return;
          }
          if (!response.data.resultVal) {
            console.log("getJson response.data.resultVal error");
            return;
          }
          if (response.data.errorCode !== "0") {
            console.log("getJson response.data.errorCode error");
            callback(response);
            return;
          }
          const res = response.data.resultVal;
          const sub = new SubscriberTool();
          const resultMap = sub.$devideByGroupBy(res, []);

          this.formItems.basic.formObj = resultMap.get(
            this.formItems.basic.modelName
          );
          this.formItems.staticIp.formObj = resultMap.get(
            this.formItems.staticIp.modelName
          );
          callback(response);
        });
    },
    saveProfile(ne, callback) {
      const formData = this.getDatas();
      if (formData) {
        const staticIpList = formData.get("staticIpObj");
        const staticIpListNew = [];
        for (var i = 0; i < staticIpList.length; i++) {
          if (staticIpList[i].ipv4Mask == ""){
            //是空删掉此属性
            this.$delete(staticIpList[i], "ipv4Mask");
          }
          if (staticIpList[i].ipv6Prefix == ""){
            this.$delete(staticIpList[i], "ipv6Prefix");
          }
          if (staticIpList[i].staticIpv4 == ""){
            this.$delete(staticIpList[i], "staticIpv4");
          }
          if (staticIpList[i].staticIpv6 == ""){
            this.$delete(staticIpList[i], "staticIpv6");
          }            
            staticIpListNew.push(staticIpList[i]);
          }        
        let params = {};
        params = {
          vo: {
            neid: ne.neid,
            supi: formData.get("supi"),
            mcc: formData.get("mcc"),
            mnc: formData.get("mnc"),
            sst: parseInt(formData.get("sst")),
            sd: formData.get("sd"),
            dnnName: formData.get("dnnName"),
            specialDataList: staticIpListNew
          },
          info: {
            msgid: this.msgId,
            neid: ne.neid
          }
        };
        if ("" == formData.get("sd")) {
          //sd不填写为空时，不下发此字段
          this.$delete(params.vo, "sd");
        }
        console.log("params", params);
        this.$axios.post(ajaxUrl.requestCommonD, params).then(response => {
          if (callback) {
            callback(response);
          }
        });
      }
    }
  },
  computed: {},
  data() {
    return {
      ne: null,
      selectedKeys: [],
      funcMap: null,
      formItems: {
        basic: {
          formId: "SpecialDataAddProfileInfo",
          modelName: "basic",
          formObj: null
        },
        staticIp: {
          title: this.$t("SpecialData.specialSign"),
          formId: "ProfileAddStaticIp",
          modelName: "staticIp",
          formObj: null,
          maxLength: 8,
          minLength: 1
        }
      },
      opCode: "add",
      msgId: "28701"
    };
  },
  beforeDestroy() {}
};
</script>
